/**
 * @module components\ghTable\vuetifyTable\vuetifyRow\vuetifyCell\template\cellIcon
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "../../base";

@Component
export default class CellIcon extends Base {}
